// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const aerodactyl: PokeData = {
  "id": 142,
  "name": "aerodactyl",
  "height": 18,
  "weight": 590,
  "base_experience": 180,
  "types": [
    PokeType.ROCK,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "fly",
    "take-down",
    "bite",
    "roar",
    "supersonic",
    "hyper-beam",
    "rock-throw",
    "agility",
    "rock-slide",
    "scary-face",
    "crunch",
    "ancient-power",
    "giga-impact",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "iron-head",
    "stone-edge",
    "sky-drop"
  ],
  "moves": [
    "bite",
    "supersonic",
    "rock-throw",
    "rock-slide",
    "scary-face",
    "crunch",
    "ancient-power",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "chatter",
    "rock-tomb",
    "aerial-ace"
  ],
  "evolution_chain": {
    "id": 71,
    "item": null,
    "species": [
      {
        "name": "aerodactyl",
        "order": 173,
        "types": [
          PokeType.ROCK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 168,
    "ability_power": 135
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
